import { normalizeInteger } from "components/FormElements/normalizeInteger";

export const normalizePhone = value => {
  const normalizedIntegerValue = normalizeInteger(value || "");
  return (
    normalizedIntegerValue.slice(0,3) +                                                      
    (normalizedIntegerValue.length > 3 ? `-${normalizedIntegerValue.slice(3,6)}` : "") +
    (normalizedIntegerValue.length > 6 ? `-${normalizedIntegerValue.slice(6,10)}` : "")
  );
};

export const normalizePhoneExt = value =>  {
  const normalizedIntegerValue = normalizeInteger(value || "");
  return (`${normalizePhone(normalizedIntegerValue)}${normalizedIntegerValue.length > 10 ? ` ext. ${normalizedIntegerValue.slice(10)}` : ""}`);
};